import { render, staticRenderFns } from "./DetailCompletedOrders.vue?vue&type=template&id=009a92fb"
import script from "../../script/orders/detailCompletedOrder.js?vue&type=script&lang=js&external"
export * from "../../script/orders/detailCompletedOrder.js?vue&type=script&lang=js&external"
import style0 from "../../less/orders/detailOrder.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports